import type Konva from "konva";
import { ShapeType, type Shape } from "@/telestrations/types/canvas";

export const CLICK_SIZE_RATIO = 0.15;

export function getShapeClickSize(stage: Konva.Stage, type: ShapeType): Partial<Shape> | null {
  const scaleY = stage.scaleY() ?? 1;
  const height = stage.height() / scaleY;
  const size = height * CLICK_SIZE_RATIO;

  switch (type) {
    case ShapeType.Ellipse:
    case ShapeType.Spotlight:
      return { radiusX: size / 2, radiusY: size / 2 };
    case ShapeType.Rectangle:
      return { width: size, height: size };
    default:
      return null;
  }
}
